import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Container, Spinner, Text, Button } from '@chakra-ui/react'
import { AdSense } from 'components'
import styled from '@emotion/styled'
import { getSearches } from 'services/firebase'
import { userContext } from 'context/userContext'
import { DocumentData } from 'firebase/firestore'
import { Search } from './Search'

export const Searches = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [searches, setSearches] = useState<DocumentData[]>([])
  const { user } = useContext(userContext)
  const navigate = useNavigate()
  const userIsLoggedIn = Boolean(user.data)

  const stopLoader = () => {
    setTimeout(() => {
      setLoading(false)
    }, 1500)
  }

  useEffect(() => {
    if (userIsLoggedIn && user?.data?.uid) {
      getSearches(user.data.uid)
        .then((response) => {
          const searchData = response.sort((a, b) => {
            const dateA = Date.parse(a.createdAt)
            const dateB = Date.parse(b.createdAt)

            if (!isNaN(dateA) && !isNaN(dateB)) {
              return dateB - dateA
            } else {
              return 0
            }
          })
          setSearches(searchData)
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          stopLoader()
        })
    } else {
      stopLoader()
    }
  }, [userIsLoggedIn])

  return (
    <Box w='100%' p={4} pb={8}>
      <Container maxW='3xl'>
        <AdWrapper>
          <AdSense dataAdSlot='7685568922' />
        </AdWrapper>
        {loading ? (
          <LoadingWrapper>
            <Spinner size='xl' />
          </LoadingWrapper>
        ) : searches && searches?.length > 0 ? (
          searches.map((search, index) => <Search key={index} search={search} />)
        ) : (
          <>
            <Text align='center'>
              You currently do not have any searches. Head back home to start your first search
            </Text>
            <ButtonWrapper>
              <Button colorScheme='gray' width='100%' onClick={() => navigate('/')}>
                Return
              </Button>
            </ButtonWrapper>
          </>
        )}
      </Container>
    </Box>
  )
}

const AdWrapper = styled.div`
  margin: 2rem 0;
`

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25rem;
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
`
